import { defineTransform } from '../transform';

function AddMetadataTransform(editor, op) {
  const {
    metadata: { key, value },
  } = op;

  if (!editor.metadata) {
    editor.metadata = {};
  }

  // Should not be able to set annotations key. Also blocked in Permissions.js
  // by validateSlateV2Operation().
  if (key === 'annotations') return;

  editor.metadata[key] = value;
}

export default AddMetadataTransform;

// Define transformations against other operations
defineTransform('add_metadata', 'add_metadata', (op1, op2, side) => {
  if (op1.metadata.key !== op2.metadata.key) return op1;

  const tOp = {
    type: 'set_metadata',
    properties: {
      key: op1.metadata.key,
      value: op1.metadata.value,
    },
    newProperties: {
      key: op1.metadata.key,
      value: op1.metadata.value,
    },
  };

  if (side === 'left') {
    tOp.properties.value = op2.metadata.value;
  } else {
    tOp.newProperties.value = op2.metadata.value;
  }

  return tOp;
});

defineTransform('add_metadata', 'remove_metadata', (op1, op2, side) => {
  // If operating on the same key, defer to the remove.
  if (op1.metadata.key === op2.metadata.key) return;

  // If the key is not the same, there's no conflict.
  return op1;
});

defineTransform('add_metadata', 'set_metadata', (op1, op2, side) => {
  // If operating on the same key, defer to the set.
  if (op1.metadata.key === op2.properties.key) return;

  // If the key is not the same, there's no conflict.
  return op1;
});

// Define transformations against standard Slate operations
// These operations don't affect metadata, so we just return op1
defineTransform('add_metadata', 'insert_text', (op1, op2, side) => op1);
defineTransform('add_metadata', 'remove_text', (op1, op2, side) => op1);
defineTransform('add_metadata', 'split_node', (op1, op2, side) => op1);
defineTransform('add_metadata', 'merge_node', (op1, op2, side) => op1);
defineTransform('add_metadata', 'move_node', (op1, op2, side) => op1);
defineTransform('add_metadata', 'insert_node', (op1, op2, side) => op1);
defineTransform('add_metadata', 'remove_node', (op1, op2, side) => op1);
defineTransform('add_metadata', 'set_node', (op1, op2, side) => op1);
defineTransform('add_metadata', 'add_mark', (op1, op2, side) => op1);
defineTransform('add_metadata', 'remove_mark', (op1, op2, side) => op1);
defineTransform('add_metadata', 'set_mark', (op1, op2, side) => op1);
defineTransform('add_metadata', 'set_selection', (op1, op2, side) => op1);

// Define transformations against annotation operations
defineTransform('add_metadata', 'add_annotation', (op1, op2, side) => op1);
defineTransform('add_metadata', 'remove_annotation', (op1, op2, side) => op1);
defineTransform('add_metadata', 'set_annotation', (op1, op2, side) => op1);
